import React, { useState, useEffect } from "react";
import { Header } from "../wrappers/Header";
import logosData from "../data/sakinler.json";
import banner from "../assets/img/3.jpg";
import Footer from "../wrappers/Footer";
import { Modal } from "react-bootstrap";
import { Fade } from "react-reveal";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { fetchSakinler } from "../redux/actions/sakinlerAction";

// Resim URL'sini oluştur
const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (imagePath.startsWith('http')) return imagePath;
  
  // logo/ ile başlıyorsa public/logo/ ekle
  if (imagePath.startsWith('logo/')) {
    return `https://kuleadmin.kulebblok.com.tr/public/${imagePath}`;
  }
  
  // uploads/ ile başlıyorsa direkt ekle
  if (imagePath.startsWith('uploads/')) {
    return `https://kuleadmin.kulebblok.com.tr/${imagePath}`;
  }
  
  // Diğer durumlarda direkt ekle
  return `https://kuleadmin.kulebblok.com.tr/${imagePath}`;
};

const Sakinler = ({ sakinler }) => {
  const dispatch = useDispatch();

  // İlk yüklemede tüm verileri çek
  useEffect(() => {
    dispatch(fetchSakinler(null, 1, 999)); // Tüm verileri çek
  }, [dispatch]);

  const [selectedResident, setSelectedResident] = useState(null);

  const openModal = (key) => {
    setSelectedResident(key);
  };

  const closeModal = () => {
    setSelectedResident(null);
  };

  return (
    <>
      <Header />
      <div className="container">
        <div className="col-12 position-relative ">
          <img className="text-main-img radius-img" src={banner} alt="Banner" />
          <div className="text-main-center text-center text-white">
            <h1>Sakinler</h1>
          </div>
        </div>
        <h2 className="text-white text-center mt-5">
          "Koç Kuleleri'nde İş, Konfor ve Prestij Bir Arada!"
        </h2>
        <div className="mb-5 mt-5 d-flex flex-wrap justify-content-around">
        {sakinler.map((key, index) => (
            <div
            key={index}
              className="col-lg-3  col-md-4 col-12 mb-4 card-sakin d-flex justify-content-center align-items-center flex-column text-white"
              onClick={() => openModal(key)}
            >
              <div className="residents-card">
                {key.image && (
                  <img
                    className="sakin-style"
                    src={getImageUrl(key.image)}
                    alt={`Sakin ${key.id}`}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      console.error('Resim yüklenemedi:', key.image);
                    }}
                  />
                )}
              </div>
              <p className="mt-1">{key.title} </p>
            </div>
          ))}
        </div>
      </div>
      <Fade bottom duration={5000}>
        {" "}
        <Modal show={selectedResident !== null} onHide={closeModal} fullscreen>
          <Modal.Header closeButton />
          <Modal.Body className="text-white">
            <div className="col-8 d-lg-flex justify-content-center">
              <div className="col-lg-3 col-12">
                {selectedResident?.image && (
                  <img
                    className="img-fluid modal-img-style "
                    src={getImageUrl(selectedResident?.image)}
                    alt={`Sakin ${selectedResident?.id}`}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      console.error('Resim yüklenemedi:', selectedResident?.image);
                    }}
                  />
                )}
              </div>
              <div className="col-lg-5 col-12 mt-lg-0 mt-5">
                <p className="p-0 m-0"> {selectedResident?.address}</p>
                <br />
                <p className="m-0 p-0"> {selectedResident?.website}</p>
                <br />
                <p className="m-0 p-0"> {selectedResident?.mail}</p>
                <br />
                <p className="m-0 p-0"> {selectedResident?.tel}</p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Fade>

      <Footer />
    </>
  );
};

Sakinler.propTypes = {
  sakinler: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    sakinler: state.sakinlerData.sakinler || [],
  };
};

export default connect(mapStateToProps)(Sakinler);
